<div class="ratio" [ngClass]="video?.aspectRatio">
  <iframe
    [src]="video?.videoUrl | safe: 'resourceUrl'"
    allowfullscreen
  ></iframe>
</div>
